module.exports = __webpack_public_path__ + "static/media/PostgresSQL.95ea0ccc.svg";